export default {
  PersonalWheelchairAssistanceFormFields__HEADER: "Personal wheelchair stowage",
  PersonalWheelchairAssistanceFormFields__MANUAL_WHEELCHAIR: "Manual wheelchair",
  PersonalWheelchairAssistanceFormFields__NO_WHEELCHAIR_STOWAGE: "No wheelchair stowage needed",
  PersonalWheelchairAssistanceFormFields__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.name} option selected. ${data.index} of ${data.length}`,
  PersonalWheelchairAssistanceFormFields__WHEELCHAIR_BATTERIES_COUNT_TEXT: "How many batteries?",
  PersonalWheelchairAssistanceFormFields__WHEELCHAIR_WITH_NON_SPILLABLE_BATTERIES:
    "Powered wheelchair with non-spillable batteries",
  PersonalWheelchairAssistanceFormFields__WHEELCHAIR_WITH_SPILLABLE_BATTERIES:
    "Powered wheelchair with spillable batteries",
};
